import "core-js/modules/es.number.constructor.js";
import 'vant/es/overlay/style';

/**
 * 跳转起泡 App 前的二次确认（纯 UI，通过 v-model:show 与 confirm 事件与父组件通信）
 */
export default {
  name: 'CirclePostOpenAppConfirm',
  props: {
    /** 是否展示 */
    show: {
      type: Boolean,
      default: false
    },
    /** 遮罩层级，需高于页面内其它 Overlay */
    zIndex: {
      type: [Number, String],
      default: 3000
    }
  },
  emits: ['update:show', 'confirm'],
  methods: {
    onMaskClick: function onMaskClick() {
      this.$emit('update:show', false);
    },
    onCancel: function onCancel() {
      this.$emit('update:show', false);
    },
    /**
     * 用户确认后由父组件执行深链 / JSBridge
     */
    onConfirm: function onConfirm() {
      this.$emit('confirm');
      this.$emit('update:show', false);
    }
  }
};